import { Container, Typography, Paper, Grid, TextField, Button, Box } from '@mui/material';
import { Helmet } from 'react-helmet';
import StaticPageLayout from '../components/layout/StaticPageLayout';
import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement form submission
    console.log(formData);
  };

  return (
    <StaticPageLayout>
      <Helmet>
        <title>Contact ET-Business - Get Support & Information</title>
        <meta name="description" content="Contact ET-Business Directory for support, business listing inquiries, or general information. Reach our team in Addis Ababa and other major Ethiopian cities for assistance with your business directory needs." />
      </Helmet>

      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          {/* Contact Information Cards */}
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Paper sx={{ p: 3, borderRadius: '12px', height: '100%' }}>
                  <Typography variant="h6" sx={{ color: '#3A551A', mb: 2, fontWeight: 600 }}>
                    General Inquiries
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#444', mb: 1 }}>
                    For general questions about our services:
                  </Typography>
                  <Typography variant="body1" component="div" sx={{ color: '#666' }}>
                    Email: <a href="mailto:info@et-business.com" style={{ color: '#3A551A', textDecoration: 'none' }}>info@et-business.com</a><br />
                    Phone: <a href="tel:+251123456789" style={{ color: '#3A551A', textDecoration: 'none' }}>+251 123 456 789</a><br />
                    Hours: Monday-Friday, 9:00-17:00 EAT
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} md={4}>
                <Paper sx={{ p: 3, borderRadius: '12px', height: '100%' }}>
                  <Typography variant="h6" sx={{ color: '#3A551A', mb: 2, fontWeight: 600 }}>
                    Business Listings
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#444', mb: 1 }}>
                    For questions about listing your business:
                  </Typography>
                  <Typography variant="body1" component="div" sx={{ color: '#666' }}>
                    Email: <a href="mailto:listings@et-business.com" style={{ color: '#3A551A', textDecoration: 'none' }}>listings@et-business.com</a><br />
                    Phone: <a href="tel:+251123456790" style={{ color: '#3A551A', textDecoration: 'none' }}>+251 123 456 790</a><br />
                    Hours: Monday-Friday, 9:00-17:00 EAT
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} md={4}>
                <Paper sx={{ p: 3, borderRadius: '12px', height: '100%' }}>
                  <Typography variant="h6" sx={{ color: '#3A551A', mb: 2, fontWeight: 600 }}>
                    Technical Support
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#444', mb: 1 }}>
                    For technical assistance:
                  </Typography>
                  <Typography variant="body1" component="div" sx={{ color: '#666' }}>
                    Email: <a href="mailto:support@et-business.com" style={{ color: '#3A551A', textDecoration: 'none' }}>support@et-business.com</a><br />
                    Phone: <a href="tel:+251123456791" style={{ color: '#3A551A', textDecoration: 'none' }}>+251 123 456 791</a><br />
                    Hours: Monday-Friday, 9:00-17:00 EAT
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          {/* Contact Form */}
          <Grid item xs={12}>
            <Paper sx={{ p: 4, borderRadius: '12px' }}>
              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Send Us a Message
              </Typography>
              <Typography variant="body1" sx={{ color: '#444', mb: 4 }}>
                Fill out the form below and we'll get back to you as soon as possible.
              </Typography>

              <Box component="form" onSubmit={handleSubmit} noValidate>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      required
                      fullWidth
                      label="Full Name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&:hover fieldset': {
                            borderColor: '#3A551A',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#3A551A',
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      required
                      fullWidth
                      label="Email Address"
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&:hover fieldset': {
                            borderColor: '#3A551A',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#3A551A',
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      label="Subject"
                      value={formData.subject}
                      onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&:hover fieldset': {
                            borderColor: '#3A551A',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#3A551A',
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      label="Message"
                      multiline
                      rows={4}
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&:hover fieldset': {
                            borderColor: '#3A551A',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#3A551A',
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      sx={{
                        bgcolor: '#3A551A',
                        '&:hover': {
                          bgcolor: '#2F4615',
                        },
                        px: 4,
                        py: 1.5,
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>

          {/* Office Location */}
          <Grid item xs={12}>
            <Paper sx={{ p: 4, borderRadius: '12px' }}>
              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Visit Our Office
              </Typography>
              <Typography variant="body1" sx={{ color: '#444', mb: 2 }}>
                Our main office is located in Addis Ababa:
              </Typography>
              <Typography variant="body1" sx={{ color: '#666' }}>
                ET-Business Directory<br />
                Bole Road, Addis Ababa<br />
                Ethiopia
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </StaticPageLayout>
  );
} 